import Header from "../components/Header"
import MainContainer from "../components/MainContainer"
import Footer from "../components/Footer"

const Home = ()=> {
    return(
        <>
            <Header>INFOPeLíCuLaS</Header>
            <MainContainer />
            <Footer>Hecho por Alexander Aparicio</Footer>
        </>
    )
}

export default Home